import type { ApolloClient } from "@apollo/client";
import { subscribeToActiveWorkspace } from "./storage";

type ResettableClient = Pick<ApolloClient<unknown>, "resetStore">;

const registered = new Set<ResettableClient>();

let isSubscribed = false;

function resetAll(): void {
  for (const client of registered) {
    client.resetStore().catch(() => undefined);
  }
}

export function registerWorkspaceScopedClient(client: ResettableClient): void {
  registered.add(client);

  if (!isSubscribed) {
    isSubscribed = true;
    subscribeToActiveWorkspace(resetAll);
  }
}
